import React, { Component } from 'react';
// import dateFormat from 'date-fns/format';
import { connect } from 'unistore/react';

import BbTcContest from '../bb-dashboard/bb-tc-contest';
import { chartWorker } from '../bb-dashboard/chart-worker'; // eslint-disable-line import/no-webpack-loader-syntax

import BbTabs from '../../components/Tabs';
import Chart from '../charts';

import { moneyFormatter } from '@utils/customLib';
import { graphPoints } from '@utils/cred';
import { getCoinProperty, getINRDecimals } from '@utils/params';
import { getRate } from '@utils/storeUtils';

let chartData = [
	{
		name: '0',
		btc: 0,
	},
];

class BbTradeChart extends Component {
	constructor(props) {
		super(props);
		const {
			currentTradingCoin: { coin },
			shownMarket: market_id,
		} = props;

		this.state = {
			min: 0,
			max: 0,
			volume: 0,
			currentTab: 2,
			chartVisible: true,
		};

		this.inrDecimals = getINRDecimals(coin, market_id);
		this.mins = { d: 0, w: 0, y: 0 };
		this.maxs = { d: 0, w: 0, y: 0 };
	}

	componentDidMount() {
		this.startBirth();
	}

	componentDidUpdate(prevProps) {
		const {
			currentTradingCoin: { coin, market_id },
			shownMarket,
		} = this.props;

		if (
			coin !== prevProps.currentTradingCoin.coin ||
			market_id !== prevProps.currentTradingCoin.market_id
		) {
			this.mins = { d: 0, w: 0, y: 0 };
			this.maxs = { d: 0, w: 0, y: 0 };
			this.inrDecimals = getINRDecimals(coin, shownMarket);
			this.startKill();
			this.startBirth();
		}
	}

	componentWillUnmount() {
		this.startKill();
	}

	updatePricePoints = async () => {
		const {
			currentTradingCoin: { coin, market_id },
		} = this.props;

		try {
			const { data } = await graphPoints(
				`flag=3&coin=${getCoinProperty(
					coin,
					'coinId'
				)}&market=${market_id}`
			);

			if (data) {
				const { volume } = JSON.parse(data);

				this.setState({
					volume,
				});
			}
		} catch (error) {
			console.log('graph', error);
		}
	};

	startBirth = tab => {
		const { currentTab } = this.state;
		const tabValue = tab !== undefined ? tab : currentTab;

		this.updatePricePoints();
		this.graphSwitch(tabValue);
		this.startGraphInterval(tabValue);
	};

	startGraphInterval = tab => {
		this.graphInterval = setInterval(() => {
			this.updatePricePoints();
			this.graphSwitch(tab);
		}, 90000);
	};

	startKill = () => {
		clearInterval(this.graphInterval);
	};

	switchGraphTab = tab => {
		if (tab !== this.state.currentTab) {
			this.startKill(tab);
			this.startBirth(tab);
		}
	};

	graphSwitch = async flag => {
		const {
			currentTradingCoin: { coin, market_id },
			usdtRate,
			currentTab,
			shownMarket,
		} = this.props;
		const coinId = getCoinProperty(coin, 'coinId');
		const { lastTradePrice } = getRate(coin, market_id);
		let graphData = [];

		switch (flag) {
			case 0:
				try {
					graphData = (
						await graphPoints(
							`flag=2&coin=${coinId}&market=${market_id}`
						)
					).data;
				} catch (error) {
					console.log('graph', error);
				}

				break;
			case 1:
				try {
					graphData = (
						await graphPoints(
							`flag=1&coin=${coinId}&market=${market_id}`
						)
					).data;
				} catch (error) {
					console.log('graph', error);
				}
				break;

			case 2:
				try {
					graphData = (
						await graphPoints(
							`flag=0&coin=${coinId}&market=${market_id}`
						)
					).data;
				} catch (error) {
					console.log('graph', error);
				}
				break;
			default:
				break;
		}

		if (graphData) {
			const chartState = chartWorker(
				graphData,
				flag,
				this.maxs,
				this.mins,
				lastTradePrice,
				coin,
				currentTab,
				shownMarket,
				usdtRate
			);

			chartData = chartState.chartData;

			this.setState({
				min: chartState.stateMin,
				max: chartState.stateMax,
				currentTab: chartState.tab,
			});
		}
	};

	render() {
		const {
			currentTradingCoin: { coin },
			ramRate,
			contests,
			className = '',
			shownMarket: market_id,
		} = this.props;
		const sym = market_id === 1 ? '$' : String.fromCharCode(8377);

		const { chartVisible, currentTab, min, max, volume } = this.state;
		const floatPlaces = getCoinProperty(coin, 'tradeFloatPlaces');

		return (
			<div id="chart__space" className={`bb-chart__space ${className}`}>
				{contests.length > 0 &&
					contests.map(
						({ type, on, ver, ...contest }) =>
							type === 'trade' && (
								<BbTcContest
									{...contest}
									key={`${contest.startTime}-${contest.coin}`}
									currentCoin={coin}
									currentMarket={market_id}
								/>
							)
					)}
				<div
					className={`bb-chart__main ${
						!chartVisible ? 'bb-chart__main--hidden' : ''
					}`}
				>
					<Chart
						currentTab={currentTab}
						chartData={chartData}
						coin={coin}
						market_id={market_id}
						sym={sym}
						min={min}
						max={max}
					/>
				</div>
				<div className="bb-tradeChart__text items-center">
					<div className="bb-priceVariation flex justify-start items-start flex-wrap flex-row  py-4">
						<div className="pr-8 pb-2">
							<div className="text-lightGray2 text-sm">High</div>
							{sym}
							{moneyFormatter(max, {
								minimumFractionDigits: 0,
								maximumFractionDigits: this.inrDecimals,
							})}
						</div>

						<div className="pr-8 pb-2">
							<div className="text-lightGray2 text-sm">Low</div>
							{sym}
							{moneyFormatter(min, {
								minimumFractionDigits: 0,
								maximumFractionDigits: this.inrDecimals,
							})}
						</div>
						<div className="pr-8 pb-2">
							<div className="text-lightGray2 text-sm">
								{coin.match(/^(ram)$/)
									? 'Vol (in 10B) (24hr)'
									: 'Volume (24hr)'}
							</div>
							{moneyFormatter(parseFloat(volume), {
								minimumFractionDigits: 0,
								maximumFractionDigits: floatPlaces,
							})}
						</div>
						{coin.match(/^(ram)$/) && (
							<div className="flex items-top  justify-end mr-8">
								<div>
									<div className="text-lightGray2 text-sm">
										Rate from Blockchain:{' '}
										<div className="bb-helpers__wrapper">
											<div className="c-toolTips__container c-toolTips__container--hoverFocus c-toolTips__container--dark c-toolTips__container--up">
												<div className="bb-helpers">
													?
												</div>

												<div
													className="c-toolTip c-toolTip--mini"
													style={{
														right: '-70%',
													}}
												>
													<div className="c-toolTip__wrap px-4">
														<p className="u-para--readable font-thin text-sm text-white">
															This is the rate of
															EOS RAM live from
															the EOS blockchain.
															You can also buy or
															sell RAM for EOS
															directly from the
															blockchain.
														</p>
														<p className="u-para--readable font-thin text-sm text-white">
															<a
																className="c-links text-white c-links--iconTri tri-right"
																target="_blank"
																rel="noopener noreferrer"
																href="https://bitbns.com/eos-ram-price-inr-india/"
															>
																<b>
																	Read more
																	here
																</b>
															</a>
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
									{ramRate}{' '}
									<span className="text-xs">
										EOS/1000 Byte
									</span>{' '}
								</div>
							</div>
						)}
					</div>
					<div className="bb-tradeChart__tabs" id="chart__tabs">
						<BbTabs
							fullWidth
							noSelector
							current={currentTab}
							type="capsule"
							chooseCurrent={this.switchGraphTab}
							tabTitles={[
								{
									label: '1Y',
								},
								{
									label: '1W',
								},
								{
									label: '1D',
								},
							]}
						/>
					</div>
				</div>

				{coin === 'neo' && (
					<div className="py-4 text-sm text-lightGray">
						Learn more about GAS distribution{' '}
						<a
							href="https://medium.com/bitbns/how-gas-is-distributed-to-neo-holders-on-bitbns-d3102918b1f5"
							rel="noreferrer noopener nofollow"
							target="_blank"
							className="c-links whitespace-nowrap font-bold text-lightGray"
						>
							<u>here</u>
						</a>
						.
					</div>
				)}
				{coin === 'npxs' && (
					<div className="py-4 text-sm text-lightGray">
						Learn more about NPXS distribution{' '}
						<a
							href="https://medium.com/bitbns/pundi-x-airdrop-update-you-must-know-10d325d6189f"
							rel="noreferrer noopener nofollow"
							target="_blank"
							className="c-links whitespace-nowrap font-bold text-lightGray"
						>
							<u>here</u>
						</a>
						.
					</div>
				)}
				{coin === 'ram' && (
					<div className="py-4 text-sm text-lightGray">
						Learn more about EOS RAM{' '}
						<a
							href="https://bitbns.com/eos-ram-price-inr-india/"
							rel="noreferrer noopener"
							target="_blank"
							className="c-links whitespace-nowrap font-bold text-lightGray"
						>
							<u>here</u>
						</a>
						.
					</div>
				)}
			</div>
		);
	}
}

export default connect(
	'currentRate, currentTradingCoin, ramRate, contests, usdtRate'
)(BbTradeChart);
